/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const FileEditFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M21 15.24v5.77a1 1 0 0 1-1 .99H4a1 1 0 0 1-1-1V9h6a1 1 0 0 0 1-1V2h10a1 1 0 0 1 1 1v3.76l-9 9V20h4.24zm.78-6.43 1.41 1.41L15.41 18H14v-1.41zM3 7l5-5v5z" />
  </Icon>
);
